import * as React from 'react'
import { Link } from 'gatsby'

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  let header

  if (isRootPath) {
    header = (
      <h1 id='site-title' className='main-heading'>
        <Link to='/'>{title}</Link>
      </h1>
    )
  } else {
    header = (
      <Link className='header-link-home' to='/'>
        {title}
      </Link>
    )
  }

  return (
    <div className='global-wrapper' data-is-root-path={isRootPath}>
      <header className='global-header'>{header}</header>
      <main>{children}</main>
      <footer>
        by{' '}
        <a href='https://twitter.com/YuhsakInoue' target='_blank' rel='noreferrer'>
          @YuhsakInoue
        </a>
      </footer>
    </div>
  )
}

export default Layout
